<template>
  <div class="organizer-container">
    <text-field
      v-model.trim="form.publicName"
      label="Organization public name"
      :validator="vs.form.publicName"
      :disabled="!enableEditing"
    />
    <text-field
      v-model.trim="form.email"
      :validator="vs.form.email"
      label="Email"
      :disabled="!enableEditing"
    />
    <div class="organizer-info">
      <logo-field v-model="form.logo" class="logo" :disabled="!enableEditing" />
      <textarea-field
        v-model="form.description"
        :validator="vs.form.description"
        label="Organizer description"
        :disabled="!enableEditing"
      />
    </div>
    <text-field v-model="form.webLink" label="Web link" :disabled="!enableEditing" />
    <div class="links">
      <text-field v-model="form.facebookLink" label="Facebook link" :disabled="!enableEditing" />
      <text-field v-model="form.instagramLink" label="Instagram link" :disabled="!enableEditing" />
    </div>
    <main-button
      text="Save"
      depressed
      class="button"
      :disabled="!enableEditing || !isFormValid"
      @click="$emit('submit')"
    />
  </div>
</template>

<script>
export default {
  name: 'organizer-profile',
  props: {
    enableEditing: {
      type: Boolean,
      default: () => false,
    },
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedLanguage: '',
      allLanguages: require('../../assets/languages.json'),
      form: this.initialValues,
    }
  },
  computed: {
    isFormValid(){
      return !this.vs.form.$invalid && !this.vs.form.$error
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted() {
    Object.entries(this.allLanguages).find(([key, value]) => {
      if (key === this.initialValues.preferredLanguage) {
        this.selectedLanguage = value.name
      }
    })
  },
  methods: {
    selectLan(language) {
      let selectedLanguage
      Object.entries(this.allLanguages).find(([key, value]) => {
        if (value.name === language) {
          return (selectedLanguage = key)
        }
      })
      this.form.preferredLanguage = selectedLanguage
    },
    getLanguagesList() {
      const list = []
      Object.entries(this.allLanguages).forEach(([key, value]) => {
        list.push(value.name)
      })

      return list
    },
  },
}
</script>

<style scoped>
.organizer-container {
  display: flex;
  row-gap: 2rem;
  flex-direction: column;
}
.organizer-name {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
}
.organizer-info {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
}
.links {
  display: flex;
  column-gap: 1.5rem;
  flex-wrap: wrap;
}
.button {
  width: 6.25rem;
  align-self: flex-end;
}
.title {
  font-family: 'Raleway';
  font-style: normal;
  margin-bottom: 0.75rem !important;
  font-weight: 600;
  font-size: 20px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
}
.title-descriptions {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #979797;
}
@media screen and (max-width: 413px) {
  .logo {
    margin: 0 auto;
  }
}
</style>
